// RecordingAliveCheck — 30분마다 «아직 녹음 중인가요?» 를 묻는 비차단 확인 카드.
//
// 🔴 훅을 쓰지 않는 **표시 전용** 컴포넌트다(props 만 받는다). RecordingProvider 가 children 뒤에서
//    직접 그리므로, 여기서 useRecording 을 부르면 RecordingContext 를 ({children}) => children 목으로
//    막아 둔 App 렌더 시험들이 'useRecording is not a function' 으로 통째로 깨진다.
// 🔴 뒤 배경(오버레이)을 두지 않고 포커스도 가두지 않는다 — 카드가 떠 있는 동안에도 녹음은 계속되고
//    사용자는 카드 밖(메모 입력 등)을 그대로 쓸 수 있어야 한다(마스터 지시 2026-10-02).
// 층 순서(zIndex): 플로팅 녹음 알약(2147483000) 위 · AppDialog 토스트·모달(2147483590·2147483600)
//    아래 — 모달이 떠 있으면 카드가 그 아래로 가 모달 우회 클릭을 유도하지 않는다.
// 색은 정보 톤(파랑)으로 둔다 — 무음 자동중지 경고(앰버)와 눈으로 구별되게.

const BTN = {
  padding: '8px 14px',
  borderRadius: 8,
  border: 'none',
  fontSize: 13,
  fontWeight: 700,
  cursor: 'pointer',
  whiteSpace: 'nowrap',
};

export default function RecordingAliveCheck({ minutes, onContinue, onStop }) {
  if (minutes == null) return null;

  return (
    <div
      data-testid="rec-alive-check"
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 'calc(16px + env(safe-area-inset-top))',
        left: 12,
        right: 12,
        margin: '0 auto',
        maxWidth: 420,
        zIndex: 2147483100,
        boxSizing: 'border-box',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: 10,
        padding: '12px 14px',
        background: '#fff',
        border: '1px solid #bfdbfe',
        borderLeft: '4px solid #2563eb',
        borderRadius: 12,
        boxShadow: '0 4px 18px rgba(0,0,0,.16)',
      }}
    >
      <span style={{ fontSize: 13, color: '#374151', flex: '1 1 180px', lineHeight: 1.5 }}>
        <b style={{ display: 'block', color: '#1d4ed8' }}>녹음 {minutes}분째입니다</b>
        아직 녹음 중인가요? 녹음은 계속되고 있습니다.
      </span>
      <button
        type="button"
        onClick={onContinue}
        style={{ ...BTN, background: '#2563eb', color: '#fff' }}
      >
        계속 녹음
      </button>
      <button
        type="button"
        onClick={onStop}
        style={{ ...BTN, background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db' }}
      >
        종료 후 업로드
      </button>
    </div>
  );
}
